module.exports = "<div class=\"calendar-div\">\r\n  <form>\r\n    <my-date-picker  #mydp=\"mydatepicker\" name=\"mydate\" [options]=\"myDatePickerOptions\" placeholder=\"mm/dd/yyyy\" \r\n      (dateChanged)=\"onDateChanged($event)\" (inputFocusBlur)=\"onInputFocusBlur($event)\" (inputFieldChanged)=\"onInputFieldChanged($event)\"  required>\r\n    </my-date-picker>\r\n  </form>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/date-picker/date-picker.component.html
// module id = ../../../../../src/app/core/components/date-picker/date-picker.component.html
// module chunks = main